import {Vue} from "vue-property-decorator";
import {InstanceId} from "@/components/history/dto/Change";

class ChangeActions {
    static fileMeta(instanceId: InstanceId): void {
        Vue.prototype.$download(instanceId.cdoId)
    }
}

export default ChangeActions;